import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SliderComponent } from './components/slider/slider.component';
import { LeaderMessageComponent } from './components/leader-message/leader-message.component';
import { NoticeBoardComponent } from './components/notice-board/notice-board.component';
import { IntroComponent } from './components/intro/intro.component';
import { FooterBarComponent } from './components/footer-bar/footer-bar.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';

@NgModule({
  declarations: [
    HomeComponent,
    DashboardComponent,
    SliderComponent,
    LeaderMessageComponent,
    NoticeBoardComponent,
    IntroComponent,
    FooterBarComponent,
    FeedbackComponent,
    BreadcrumbComponent
  ],
  imports: [
    HomeRoutingModule,
    SharedModule,
  ]
})
export class HomeModule { }
